export default orderNumber => `
  {
    order(orderNumber: "${orderNumber}") {
      number
      completedAt
      email
      isTaxIncluded
      shippingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          name
          id
        }
      }
      billingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          name
          id
        }
      }
      shippingRates {
        id
        name
        price
        displayPrice
        selected
        estimatedDelivery
        notice
      }
      items {
        variantId
        color
        groupName
        imageUrl
        price
        productPath
        quantity
        size
      }
      promotionAdjustment {
        code
        amount
      }
      taxAdjustments {
        label
        amount
      }
    }
  }
`
